import React from 'react';
import CustomLoader from '../common/CustomLoader';
import ParentContentCard from '../common/ParentContentCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';

const LoadingCard = ({
  headerText = 'Creating...',
  loadingText = 'Please wait...',
  loadingFlag = false,
  headerIcon = 'aiModelConfig',
}) => {
  return (
    <CommonPageComponent>
      <div className="row justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="col-12 text-center">
          <ParentContentCard title={headerText} icon={headerIcon}>
            <div className="justify-content-center align-items-center py-5">
              <div>
                <CustomLoader loading={loadingFlag} size="20px" color="#303453" />
              </div>
              <div className="text-center">
                <p className="mt-3 font-weight-bold text-center">{loadingText}</p>
              </div>
            </div>
          </ParentContentCard>
        </div>
      </div>
    </CommonPageComponent>
  );
};

export default LoadingCard;
